// extracted by css-extract-rspack-plugin
export default {"button":"KP6Gf"};